export const contactsData = {
    email: 'gemechutiko@gmail.com',
    phone: '+1 (641) 632-2653',
    address: 'Farmington, Minnesota, United States - 55024',

    sheetAPI: ''
}